// removed by extract-text-webpack-plugin
module.exports = {"topMenu":"_2ar6jUHSYGIvS4aBBhcPRz","menuLogo":"_1i8XcemkrGibc_SDKf9f6q","accountHelp":"_2wVJrl_y6Y_IS_Qu9-KkLH","burger":"_8urfMZOc_qPnhZs2UqQF6","accountDetails":"_3_zWv8aIiZwWvuip0YAHT8","accountAva":"WGkFQEqkMLYzNOYANj0l2","helpTrigger":"_2HuZ6Rr04owZIfJmowOXoQ"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/EquipComponents/EquipMenu/index.css
// module id = 247
// module chunks = 0